import { render } from "./ProjectPrintPage.vue?vue&type=template&id=86a25174&scoped=true"
import script from "./ProjectPrintPage.vue?vue&type=script&lang=js"
export * from "./ProjectPrintPage.vue?vue&type=script&lang=js"

import "./ProjectPrintPage.vue?vue&type=style&index=0&id=86a25174&scoped=true&lang=css"

import exportComponent from "/home/ec2-user/ContentMoverNodejs/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-86a25174"]])

export default __exports__